package map.views.workplacetools

import search.searchFilterStores.ActiveKeywordsStore

class ActiveArchetypeSearchKeywordsStore : ActiveKeywordsStore()
